<template>
    <b-modal id="modal-leads-checkbox"
             hide-footer
             centered
             :visible="isVisible"
             :title="header"
             size="xl"
    >
        <div class="row">
            <div class="col-12">
                <div>
                    {{  content }}
                </div>
            </div>
        </div>
        <div class="row mt-3 d-flex justify-content-end">
            <button type="button" class="btn btn-secondary mr-3" @click="close">Schliessen</button>
        </div>
    </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
    name: 'ModalLeadsCheckbox',

    components: {
        BModal
    },

    props: {
        header: '',
        content: '',
        visible: false,
    },

    data() {
        return {
            isVisible: this.visible
        }
    },

    watch: {
        visible: function(val) {
            this.isVisible = val
        }
    },

    methods: {
        close(){
            this.isVisible = false
        },
    }
}
</script>